export enum ProcessPartnerTypes {
  CARRIER = 'CARRIER',
  SURVEYOR = 'SURVEYOR',
  CLAIM_HANDLER = 'CLAIM_HANDLER',
  BEARER_OF_RISK = 'BEARER_OF_RISK',
  DEALER = 'DEALER',
  PLANT = 'PLANT',
  GC_AGENT = 'GC_AGENT',
}
